import script from "./product5View.vue?vue&type=script&setup=true&lang=js"
export * from "./product5View.vue?vue&type=script&setup=true&lang=js"

import "./product5View.vue?vue&type=style&index=0&id=3d59b084&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d59b084"]])

export default __exports__